module.exports = __webpack_public_path__ + "static/Neko-ea36ae07174cfb302c67009f2794c453.gif";